namespace Solovis.Reports.Layouts {

    export class BlockWithHeaderLayoutPart extends LayoutPart {

        private _headerPart;
        private _contentPart;
        private _contentExpanded;
        private _headerCurrentlyVisible;
        private _contentCurrentlyVisible;


        constructor(options) {
            super(options);

            this._headerPart = null;
            this._contentPart = null;
            this._contentExpanded = true;

            this._headerCurrentlyVisible = this._currentlyVisible;
            this._contentCurrentlyVisible = this._currentlyVisible;
        }

        public _updateAllChildPartsVisibility() {
            if (this._headerPart) {
                if (this._currentlyVisible != this._headerCurrentlyVisible) {
                    this._updateChildPartParentVisibility(this._headerPart, this._currentlyVisible);
                    this._headerCurrentlyVisible = this._currentlyVisible;
                }
            }

            if (this._contentPart) {
                var contentShouldBeVisible = this._currentlyVisible && this._contentExpanded;
                if (contentShouldBeVisible != this._contentCurrentlyVisible) {
                    this._updateChildPartParentVisibility(this._contentPart, contentShouldBeVisible);
                    this._contentCurrentlyVisible = contentShouldBeVisible;
                }
            }
        }

        public createPart(parentElement) {
            var self = this;

            var blockWrapperHolderDiv = $("<div>").css("display", "none").appendTo(parentElement);
            this.layoutDiv = blockWrapperHolderDiv;

            var blockWrapperDiv = $("<div>").addClass("report-block-with-header-layout").appendTo(blockWrapperHolderDiv);

            if (this.partDefinition.style) {
                this.reportControl._applyStyleToPartContainer(this.partDefinition.style, blockWrapperDiv);
            }

            var headerDiv = $("<div>").addClass("report-block-header").appendTo(blockWrapperDiv);

            var headerToggleDiv = $("<div>").addClass("no-print").css("float", "right").appendTo(headerDiv);

            var headerContentDiv = $("<div>").addClass("report-block-header-content").appendTo(headerDiv);
            if (this.partDefinition.header) {
                if (this.partDefinition.header.headerText) {
                    var childPart = self.reportControl._createPartContainer({
                        parentElement: headerContentDiv,
                        partDefinition: {
                            html: $("<h3>").text(this.partDefinition.header.headerText).get(0).outerHTML
                        }
                    });

                    this.childPartList.push(childPart);
                    this._headerPart = childPart;
                }
                else {
                    var childPart = self.reportControl._createPartContainer({ parentElement: headerContentDiv, partDefinition: this.partDefinition.header });
                    this.childPartList.push(childPart);
                    this._headerPart = childPart;
                }
            }

            var contentDiv = $("<div>").addClass("report-block-content").appendTo(blockWrapperDiv);
            if (this.partDefinition.noPaddingOnContent) {
                contentDiv.css("padding", "0");
            }

            if (this.partDefinition.content) {
                var childPart = self.reportControl._createPartContainer({ parentElement: contentDiv, partDefinition: this.partDefinition.content });
                this.childPartList.push(childPart);
                this._contentPart = childPart;
            }

            // Create toggle links if needed.
            if (this.partDefinition.allowCollapse) {
                var headerCollapseLink = $("<a>").html('<span class="ui-icon ui-icon-carat-1-n"></span>')
                    .css("display", "inline-block").css("vertical-align", "middle").appendTo(headerToggleDiv);
                headerCollapseLink.click(function () {
                    headerCollapseLink.css("display", "none");
                    headerExpandLink.css("display", "inline-block");

                    self._contentExpanded = false;
                    contentDiv.toggle(false);
                    self._updateAllChildPartsVisibility();
                });

                var headerExpandLink = $("<a>").html('<span class="ui-icon ui-icon-carat-1-s"></span>')
                    .css("display", "none").css("vertical-align", "middle").appendTo(headerToggleDiv);
                headerExpandLink.click(function () {
                    headerExpandLink.css("display", "none");
                    headerCollapseLink.css("display", "inline-block");

                    self._contentExpanded = true;
                    contentDiv.toggle(true);
                    self._updateAllChildPartsVisibility();
                });
            }
        }
    }

}
